import { Helmet } from 'react-helmet';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import {
  Box, Button, Container, Card, CardContent, TextField, SvgIcon, InputAdornment
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import { CATEGORY_API } from "../../apiContants";

/* eslint-disable camelcase */

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    height: "25px!important",
    paddingTop: "5px!important",
  },
  padding: {
    paddingTop: "15px!important",
  },
  buttonsearch: {
    marginTop: "15px!important",
    marginLeft: "15px!important",
  },
  buttonclear: {
    marginTop: "15px!important",
    width: "130px",
  },
  buttonshow: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    backgroundColor: "#5664d2!important",
    color: "white!important",
    borderRadius: "0px!important",
  },
  papervalue: {
    padding: theme.spacing(2),
    border: "1px solid blue!important",
    textAlign: "center",
    color: "black!important",
    borderRadius: "0px!important",
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
}));

const Category = () => {
  const classes = useStyles();
  const [reg, regSet] = useState(Array);
  const [data, dataSet] = useState(Array);
  const [loading, setLoading] = useState(true);
  const [value, setValues] = React.useState({
    name: "",
  });
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [openAddnew, setOpenAddnew] = React.useState(false);

  const handleOpen = (item, idx) => {
    dataSet(item);
    setOpen(true);
  };
  const handleOpenAddnew = () => {
    setOpenAddnew(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseAddnew = () => {
    setOpenAddnew(false);
  };
  const handleChangeForm = (name) => (event) => {
    setValues({ ...value, [name]: event.target.value });
  };

  const totalmint_volume = async () => {
    const total_mint = await axios.get(CATEGORY_API);
    regSet(total_mint.data.category);
  };

  const update_list = async (data) => {
    const update_category = await axios.put(
      CATEGORY_API + `?id=${data.id}&name=${value.name}`
    );
    setLoading(!loading);
    setOpen(false);
  };

  const new_category = async () => {
    const addnew_category = await axios.post(
      CATEGORY_API + `?name=${value.name}`
    );
    setLoading(!loading);
    setOpenAddnew(false);
  };

  useEffect(() => {
    totalmint_volume();
  }, [loading]);
  const body = (
    <Box textAlign="center">
      <div style={modalStyle} className={classes.modal}>
        <h2>Enter here Category name :</h2>
        <Grid justifyContent="center" alignItems="center" spacing={3} container>
          <Grid className={classes.padding} item xs={12}>
            <TextField
              onChange={handleChangeForm("name")}
              className={classes.padding}
              placeholder="Enter here"
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              id="standard-basic"
            />
          </Grid>
          <Grid className={classes.padding} item xs={12}>
            <Button
              onClick={() => update_list(data)}
              variant="contained"
              color="primary"
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
  const bodyAddnew = (
    <Box textAlign="center">
      <div style={modalStyle} className={classes.modal}>
        <h2>Enter here Category name :</h2>
        <Grid justifyContent="center" alignItems="center" spacing={3} container>
          <Grid className={classes.padding} item xs={12}>
            <TextField
              onChange={handleChangeForm("name")}
              className={classes.padding}
              placeholder="Enter here"
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              id="standard-basic"
            />
          </Grid>
          <Grid className={classes.padding} item xs={12}>
            <Button
              onClick={() => new_category()}
              variant="contained"
              color="primary"
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
  return (
    <>
      <Helmet>
        <title>Customers | Material Kit</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ mt: 3 }}>
            <Card>
              <CardContent>
                <Box sx={{ maxWidth: 1200 }}>
                  <Grid spacing={3} container>
                    <Grid className={classes.padding} item xs={2}>
                      <h2>list 2 :</h2>
                    </Grid>
                    {reg.map((item, idx) => (
                      <Grid className={classes.padding} item xs={2}>
                        <Button
                          className={classes.buttonclear}
                          type="button"
                          variant="contained"
                          color="primary"
                          onClick={() => handleOpen(item, idx)}
                        >
                          {item.name}
                        </Button>
                      </Grid>
                    ))}
                    <Grid className={classes.padding} item xs={2}>
                      <Button
                        className={classes.buttonclear}
                        type="button"
                        variant="contained"
                        color="secondary"
                        onClick={() => handleOpenAddnew()}
                      >
                        Add new
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Container>
      </Box>
      <Box textAlign="center">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </Modal>
      </Box>
      <Box textAlign="center">
        <Modal
          open={openAddnew}
          onClose={handleCloseAddnew}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {bodyAddnew}
        </Modal>
      </Box>
    </>
  );
};

export default Category;
